module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SkRankingView.js"));
	}, "SkRankingView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SkRankingView!./src/pages/Shop/Home/SkRanking/SkRankingView.js
// module id = 923
// module chunks = 438